<div class="row">
    <div class="col col-md-12">


        <!-- Medication Add Form -->
        <div class="card mb-4">
            <div class="card-body">
                <form (ngSubmit)="onAddItemToList()">
                    <div class="row g-3 align-items-end">
                        <div class="col-3">
                            <label for="garantie_id" class="form-label fw-semibold required">
                                <i class="fas fa-procedures me-1"></i>
                                Garantie
                            </label>
                            <ng-select id="garantie_id" [items]="itemsGarantie" bindLabel="libelle" bindValue="id"
                                [(ngModel)]="itemToSave.garantie_id" name="garantie_id" [searchable]="true" [clearable]="true"
                                placeholder="Sélectionnez" (change)="onSelectGarantie()"
                                class="custom-select">
                            </ng-select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label fw-semibold">Acte</label>
                            <app-scroll-search-acte [cancelItemSelected]="cancelItemSelected"
                                (itemMedicamentSelected)="onSelectMedocPro($event)"
                                [garantie_id]="garantie_id"></app-scroll-search-acte>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label fw-semibold">Quantité</label>
                            <input mask="separator" type="text" class="form-control form-control-sm"
                                [(ngModel)]="itemToAdd.quantite" name="quantite" required>
                        </div>
                        <div class="col-md-1">
                            <button type="submit" class="btn btn-primary btn-sm w-100">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </form>
                <br>

                <div class="table-responsive">
                    <table class="table table-hover table-bordered mb-0 medication-table">
                        <thead class="table-light">
                            <tr>
                                <th>#</th>
                                <th>Acte</th>
                                <th>Quantité</th>

                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of itemsElement; let i=index" [ngClass]="{
                                        'table-warning': item.is_entente_prealable,
                                        'table-danger': item.is_exclu,
                                        'table-success': !item.is_exclu && !item.is_entente_prealable
                                    }">
                                <td>{{ i+1 }}</td>
                                <td>{{ item.acte_libelle }}</td>
                                <td>{{ item.quantite }}</td>
                                <td class="text-center">
                                    <button (click)="itemsElement.splice(i,1)" class="btn btn-danger btn-sm">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="!itemsElement?.length">
                                <td colspan="12" class="text-center py-4 text-muted">
                                    <i class="fas fa-info-circle me-2"></i>Aucun acte ajouté
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>

                <div class="row">

                    <div class="col-md-6">
                        <span class="badge bg-success me-2">Garanti</span>
                        <span class="badge bg-warning text-dark me-2">Entente préalable</span>
                        <span class="badge bg-danger">Non garanti</span>
                    </div>
                    <div class="col-md-4">
                        <!-- <label class="form-label fw-semibold">Affection</label> -->
                        <!-- <ng-select [items]="itemsAffection" bindLabel="libelle" bindValue="id"
                            [(ngModel)]="itemToSave.affection_id" placeholder="Affection" class="form-control-sm">
                        </ng-select> -->
                        <textarea [(ngModel)]="itemToSave.renseignement_clinique" class="form-control"
                            name="renseignement_clinique" placeholder="Rensignement clinique"></textarea>
                    </div>
                    <div class="col-md-2">
                        <input (change)="uploadFile($event)" type="file" class="form-control" id="fichier1"
                            name="fichier1">
                        <!-- <label class="input-group-text" for="fichier1">Fichier</label> -->
                    </div>
                    <!-- <div class="col-md-2" style="visibility: hidden;">
                        <ng-select disabled [items]="itemsModePrescription" bindLabel="libelle" bindValue="code"
                            [(ngModel)]="itemToSave.mode_prescription" placeholder="Mode prescription"
                            class="form-control-sm">
                        </ng-select>
                    </div> -->
                </div>
                <!-- </div> -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="form-label fw-semibold">Praticien</label>
                        <ng-select [items]="itemsPraticien" bindLabel="full_name" bindValue="id"
                            [(ngModel)]="itemToSave.praticien_id"
                            placeholder="Sélectionnez le praticien"
                            class="form-control-sm">
                        </ng-select>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                    <button style="width: 100%;" [disabled]="!itemsElement?.length"
                        (click)="confirmSaveItem(itemToSave)" class="btn btn-success px-4">
                        <i class="fas fa-paper-plane me-2"></i>Soumettre la prescription
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Patient Information -->


<!-- Prescription Form -->